import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showModal } from '../actions/modal'

import {
  // Link,
  NavLink,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

import Campaigns from './Campaigns'

class CampaignsPage extends Component {
  state = {}

  openInModal = (Component) => {
    this.props.dispatch(showModal(Component));
  }

  render() {
    const { match } = this.props;
    const { campaigns } = this.props;
    const byType = (arr, type) => arr.filter((item) => item.type === type);
    return (
      <div className="container content">
        <div className="flex-between">
          <h2>Active Campaigns</h2>
          <div className="flex">
            <NavLink exact className="link" 
              activeClassName="link--active" 
              to={`${match.url}`}>All</NavLink>
            <NavLink className="link" 
              activeClassName="link--active" 
              to={`${match.url}/email`}>Email</NavLink>
            <NavLink className="link" 
              activeClassName="link--active" 
              to={`${match.url}/social`}>Social</NavLink>
            <NavLink className="link" 
              activeClassName="link--active" 
              to={`${match.url}/sms`}>SMS</NavLink>
            <NavLink className="link" 
              activeClassName="link--active" 
              to={`${match.url}/push`}>Push</NavLink>
          </div>
        </div>
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => 
            <Campaigns collection={campaigns} />}/>
          <Route path={`${match.url}/email`} render={(props) => 
            <Campaigns collection={byType(campaigns, 'email')} />}/>
          <Route path={`${match.url}/social`} render={(props) => 
            <Campaigns collection={byType(campaigns, 'facebook')} />}/>
          <Route path={`${match.url}/sms`} render={(props) => 
            <Campaigns collection={byType(campaigns, 'sms')} />}/>
          <Route path={`${match.url}/push`} render={(props) => 
            <Campaigns collection={byType(campaigns, 'push')} />}/>
          <Redirect to={`${match.url}`}/>
        </Switch>
        {/* <h2>Past Campaigns</h2> */}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const active = state.campaigns.active.filter(item => item.active);
  const past = state.campaigns.active.filter(item => !item.active);

  return { campaigns: state.campaigns.active }
}

export default connect(mapStateToProps)(CampaignsPage)


// WEBPACK FOOTER //
// ./src/components/CampaignsPage.js